import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { GroupService } from 'src/app/api/departure/group.service';
import { SearchTransportComponent } from 'src/app/components/search-transport/search-transport.component';
import { SearchGuidesComponent } from 'src/app/components/search-guides/search-guides.component';
import { SearchTourComponent } from 'src/app/components/search-tour/search-tour.component';
declare var $: any;
import * as moment from 'moment';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import { ToolsService } from 'src/app/utils/tools.service';
import SwalAlert from 'src/app/utils/swalalert';
import { constants } from 'src/app/constants';
import { SearchBookingsComponent } from 'src/app/components/search-bookings/search-bookings.component';
import { SearchAgenciesComponent } from 'src/app/components/search-agencies/search-agencies.component';
import { ClientExtendsComponent } from 'src/app/sale/client/client-extends/client-extends.component';
import { SearchClientComponent } from 'src/app/components/search-client/search-client.component';
import { GeneralService } from 'src/app/api/config/general.service';
import { BookingsHotelExtendsComponent } from '../../bookings/bookings-hotel-extends/bookings-hotel-extends.component';

@Component({
  selector: 'app-receiveds-form',
  templateUrl: './receiveds-form.component.html',
  styleUrls: ['./receiveds-form.component.css']
})
export class ReceivedsFormComponent implements OnInit {
  private thisComponent: ReceivedsFormComponent;
  @ViewChild(SearchBookingsComponent) SearchBookingsComponent: any;
  @ViewChild(SearchAgenciesComponent) SearchAgenciesComponent: any;
  @ViewChild(SearchClientComponent) SearchClientComponent: any;
  @ViewChild(ClientExtendsComponent) ClientExtendsComponent: any;
  @ViewChild(BookingsHotelExtendsComponent) BookingsHotelExtendsComponent: any;

  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables ====
  isClientSelected: boolean = false;
  bookingSelected: any = null;
  agencySelected: any = null;
  clientSelected: any = null;
  detail_tours: any = [];

  //init variables
  originsbooking: any = [];
  arrivalplaces: any = [];
  vehiclestours: any = [];
  shifttours: any = [];
  managers: any = [];

  tours_selecteds: any = [];
  detail_hotels: any = [];

  is_booking_checked: boolean = false;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private bookingsService: BookingsService,
    private route: ActivatedRoute,
    private generalService: GeneralService,
    private alertifyMsg: AlertifyHelper,
    private alert: SwalAlert,
    public toolsService: ToolsService,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      code: [null],
      client_id: [null],
      agency_id: [null],
      agency_manager_id: [null],
      arrivalplace_id: [null],
      nro_pax: [null, [Validators.required]],
      tel_1: [null, [Validators.required]],
      tel_2: [null],
      date_arrival: [null],
      time_arrival: [null],
      arrival_place: [null],
      date_departure: [null],
      reference_voucher: [null],
      reference_location: [null],
      contact_emergency: [null],
      telephone_emergency: [null],
      is_detail_subtotaltour: [null],
      register_flight: [null],
      observations: [null],
      text_amount: [null],
      subtotal_tour: [0],
      total: [0],
      total_paid: [0],
      is_control_total_received: [false],
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    let component_ = this.thisComponent;
    this.getArrivalBooking();
    this.getVehicleTour();
    this.getShiftTours();

    setTimeout(() => {
      (<any>$('#agency_manager_id')).attr('disabled', true);
      this.SearchAgenciesComponent.focused();
    }, 250);

    if (this.isEdit) {
      this.editData();
    } else {
      this.generateCalendarDateArrival();
    }
    (<any>$('[data-toggle="tooltip"]')).tooltip();
    this.navigationTrackerService.initializeMenu(this.route);
  }

  editData() {
    this.bookingsService.get(this.checkId).subscribe({
      next: (data: any) => {
        let item_ = data.data.item;
        this.item.patchValue({
          code: item_.code,
          client_id: item_.client_id,
          agency_manager_id: item_.agency_manager_id,
          bookingorigin_id: item_.bookingorigin_id,
          arrivalplace_id: item_.arrivalplace_id,
          date_arrival: item_.date_arrival,
          time_arrival: item_.time_arrival,
          date_departure: item_.date_departure,
          arrival_place: item_.arrival_place,
          nro_pax: item_.nro_pax,
          reference_voucher: item_.reference_voucher,
          observations: item_.observations,
          reference_location: item_.reference_location,
          subtotal_tour: item_.subtotal_tour,
          total: item_.total,
          total_paid: item_.total_paid,
          text_amount: item_.text_amount,
          is_control_total_received: item_.is_control_total_received,
        });

        this.detail_tours = data.data.tours;
        this.detail_hotels = data.data.hotels;
        this.selectedAgenciesSearch(item_.agency_data);
        this.selectedClientSearch(item_.client_data);

        setTimeout(() => {
          for (let index in this.detail_tours) {
            let tour_ = this.detail_tours[index];
            let component_ = this.thisComponent;
            // date assigned ---------
            (<any>$('#date_assigned' + index)).daterangepicker({
              singleDatePicker: true,
              autoUpdateInput: false,
              showDropdowns: true,
              autoApply: true,
              locale: {
                format: 'YYYY-MM-DD'
              }
            }).on('apply.daterangepicker', function(ev:any, picker:any) {
                (<any>$('#date_assigned' + index)).val(picker.startDate.format('YYYY-MM-DD'));
                component_.setDateAssigned(index, picker.startDate.format('YYYY-MM-DD'));
            });
            // (<any>$('#date_assigned' + index)).daterangepicker(
            //   {
            //     singleDatePicker: true,
            //     autoUpdateInput: false,
            //     showDropdowns: true,
            //     autoApply: true,
            //     minDate: moment().format('YYYY-MM-DD'),
            //     locale: {
            //       format: 'YYYY-MM-DD'
            //     }
            //   },
            //   function(chosen_date: any) {
            //     (<any>$('#date_assigned' + index)).val(
            //       chosen_date.format('YYYY-MM-DD')
            //     );
            //     component_.setDateAssigned(
            //       index,
            //       chosen_date.format('YYYY-MM-DD')
            //     );
            //   }
            // );

            // vehicle tours ---------
            (<any>$('#vehicleTourSelected' + index)).html('');
            for (let i in this.vehiclestours) {
              let item_ = this.vehiclestours[i];
              (<any>$('#vehicleTourSelected' + index)).append(
                $('<option>', {
                  value: item_.id,
                  text: item_.description
                })
              );
            }
            (<any>$('#vehicleTourSelected' + index)).val(tour_.vehicle_tour);

            // shift tours ---------
            (<any>$('#shiftTourSelected' + index)).html('');
            for (let i in this.shifttours) {
              let item_ = this.shifttours[i];
              (<any>$('#shiftTourSelected' + index)).append(
                $('<option>', {
                  value: item_.id,
                  text: item_.description
                })
              );
            }
            (<any>$('#shiftTourSelected' + index)).val(tour_.shift_tour);
          }

          this.generateCalendarDateArrival();
        }, 150);
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  generateCalendarDateArrival() {
    let component_ = this.thisComponent;
    let mindate: any = null;
    if (this.item.value.date_arrival == null) {
      mindate = new Date();
    }
    (<any>$('#date_arrival')).daterangepicker(
      {
        singleDatePicker: true,
        autoUpdateInput: false,
        showDropdowns: true,
        autoApply: true,
        // minDate: mindate,
        locale: {
          format: 'YYYY-MM-DD'
        }
      },
      function(chosen_date: any) {
        (<any>$('#date_arrival')).val(chosen_date.format('YYYY-MM-DD'));
        component_.setDateArrival(chosen_date.format('YYYY-MM-DD'));
      }
    );

    (<any>$('#date_departure')).daterangepicker(
      {
        singleDatePicker: true,
        autoUpdateInput: false,
        showDropdowns: true,
        autoApply: true,
        // minDate: mindate,
        locale: {
          format: 'YYYY-MM-DD'
        }
      },
      function(chosen_date: any) {
        (<any>$('#date_departure')).val(chosen_date.format('YYYY-MM-DD'));
        component_.setDateDeparture(chosen_date.format('YYYY-MM-DD'));
      }
    );
  }

  setDateArrival(date_assigned: any) {
    this.item.patchValue({
      date_arrival: date_assigned
    });
  }

  setDateDeparture(date_assigned: any) {
    this.item.patchValue({
      date_departure: date_assigned
    });
  }

  getVehicleTour() {
    this.generalService.listVehiclesTours().subscribe({
      next: (data: any) => {
        this.vehiclestours = data;
      }
    });
  }

  getShiftTours() {
    this.generalService.listShiftTours().subscribe({
      next: (data: any) => {
        this.shifttours = data;
      }
    });
  }

  getArrivalBooking() {
    this.generalService.listArrivalBooking().subscribe({
      next: (data: any) => {
        this.arrivalplaces = data;
      }
    });
  }

  selectedAgenciesSearch(item_: any) {
    this.agencySelected = item_;
    this.managers = item_.managers_data;
    (<any>$('#agency_manager_id')).attr('disabled', false);
    this.item.patchValue({
      agency_id: this.agencySelected.id
    });
  }

  removeAgencies() {
    this.agencySelected = null;
    this.managers = [];
    this.item.patchValue({
      agency_id: null,
      agency_manager_id: null
    });
    setTimeout(() => {
      this.SearchAgenciesComponent.focused();
      (<any>$('#agency_manager_id')).attr('disabled', true);
    }, 150);
  }

  selectedClientSearch(item_: any) {
    this.isClientSelected = true;
    this.clientSelected = item_;
    this.item.patchValue({
      client_id: item_.id,
      tel_1: item_.cellphone,
      tel_2: item_.telephone
    });
  }

  removeClient() {
    this.isClientSelected = false;
    this.clientSelected = {};
    this.item.patchValue({
      client_id: null
    });
    setTimeout(() => {
      this.SearchClientComponent.focused();
    }, 150);
  }

  extendsClient(event: any): void {
    this.selectedClientSearch(event);
  }

  selectedTourSearch(item_: any) {
    if (this.toolsService.notExistObjInArr(item_, this.detail_tours)) {
      item_.quantity = null;
      item_.date_assigned = null;
      item_.date_realized = null;
      item_.observation = null;
      item_.price = null;
      item_.subtotal = 0;
      item_.is_open = false;
      // item_.price_corporate = null;
      item_.assigned_payment = null;
      this.detail_tours.push(item_);

      setTimeout(() => {
        this.initialDateAssigned(item_, this.thisComponent);
        this.initialVehicleTour(item_);
        this.initialShiftTour(item_);
      }, 100);

      // this.recalculateTotalTour();
    } else {
      this.alertifyMsg.warning(
        'El tour ' + item_.description + ' ya se encuentra agregado'
      );
    }
  }

  initialDateAssigned(tour: any, component: any) {
    var index = this.detail_tours.indexOf(tour);
    this.detail_tours[index].null = null;
    (<any>$('#date_assigned' + index)).daterangepicker({
        singleDatePicker: true,
        autoUpdateInput: false,
        showDropdowns: true,
        autoApply: true,
        locale: {
          format: 'YYYY-MM-DD'
        }
    }).on('apply.daterangepicker', function(ev:any, picker:any) {
        (<any>$('#date_assigned' + index)).val(picker.startDate.format('YYYY-MM-DD'));
        component.setDateAssigned(index, picker.startDate.format('YYYY-MM-DD'));
    });
    // (<any>$('#date_assigned' + index)).daterangepicker(
    //   {
    //     singleDatePicker: true,
    //     autoUpdateInput: false,
    //     showDropdowns: true,
    //     autoApply: true,
    //     // minDate: new Date(),
    //     locale: {
    //       format: 'YYYY-MM-DD'
    //     }
    //   },
    //   function(chosen_date: any) {
    //     (<any>$('#date_assigned' + index)).val(
    //       chosen_date.format('YYYY-MM-DD')
    //     );
    //     component.setDateAssigned(index, chosen_date.format('YYYY-MM-DD'));
    //   }
    // );
  }

  setDateAssigned(index: any, date_assigned: any) {
    this.detail_tours[index].date_assigned = date_assigned;
  }

  initialVehicleTour(tour: any) {
    var index = this.detail_tours.indexOf(tour);
    var options = this.vehiclestours;
    console.log(options);

    (<any>$('#vehicleTourSelected' + index)).html('');
    for (let i in options) {
      let item_ = options[i];
      (<any>$('#vehicleTourSelected' + index)).append(
        $('<option>', {
          value: item_.id,
          text: item_.description
        })
      );
    }

    (<any>$('#vehicleTourSelected' + index)).val(options[0].id);
    this.detail_tours[index].vehicle_tour = options[0].id;
  }

  initialShiftTour(tour: any) {
    let index = this.detail_tours.indexOf(tour);
    let options = this.shifttours;
    (<any>$('#shiftTourSelected' + index)).html('');
    for (let i in options) {
      let item_ = options[i];
      (<any>$('#shiftTourSelected' + index)).append(
        $('<option>', {
          value: item_.id,
          text: item_.description
        })
      );
    }

    (<any>$('#shiftTourSelected' + index)).val(tour.shift);
    this.detail_tours[index].shift_tour = tour.shift;
  }

  changeVehicleTour(param: any, index: number): void {
    this.detail_tours[index].vehicle_tour = param.value;
  }

  changeShiftTour(param: any, index: number): void {
    this.detail_tours[index].shift_tour = param.value;
  }

  changeToursQuantity(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_tours[index].quantity = value_;
    }
  }

  changePriceCorporate(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_tours[index].price_corporate = value_;
    }
  }

  changeAssignedPayment(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.detail_tours[index].assigned_payment = value_;
    }
  }

  changeToursObservation(param: any, index: number): void {
    this.detail_tours[index].observation = param.value;
  }

  removeTour(id: any, index: any) {
    this.detail_tours.splice(index, 1);
  }

  calculateTotal() {
    let total_ = 0;
    let calc_ =
      total_ +
      (
        Number(this.item.value.subtotal_tour) +
        Number(this.item.value.subtotal_hotel)
      ).toFixed(2);
    this.item.patchValue({
      total: calc_
    });
  }

  // hotel booking
  extendsBookingHotel(data: any) {
    let obj_: any = {};
    obj_.id = data.item.id;
    obj_.hotel_id = data.item.hotel_id;
    obj_.tradename = data.hotel.tradename;
    obj_.reference_voucher = this.item.value.reference_voucher;
    obj_.cellphone = data.hotel.cellphone;
    obj_.citietouristic = data.hotel.citietouristic.description;
    obj_.detail_bedrooms = data.detail_bedrooms;
    obj_.total = data.total_booking;
    obj_.total_sale = 0;
    obj_.total_paid = 0;

    if (data.isEdit) {
      let update_ = this.toolsService.searchObjById(
        obj_.id,
        this.detail_hotels
      );

      let index = this.detail_hotels.indexOf(update_);
      this.detail_hotels[index] = obj_;
      this.alertifyMsg.success(
        'El registro de hotel ' + obj_.tradename + ' ha sido actualizado'
      );
    } else {
      this.detail_hotels.push(obj_);
      this.alertifyMsg.success('Registro de hotel agregado con éxito');
    }
  }

  removeDetailHotel(index: any, data_hotel: any) {
    console.log(data_hotel);
    let validation = false;
    for (let i in data_hotel.detail_bedrooms) {
      if (data_hotel.detail_bedrooms[i].is_paid) {
        validation = true;
        break;
      }
    }

    if (validation) {
      this.alert.msgWarning(
        'Existe un registro en * REPORTE CUADRE DE HOTEL *, por lo que no se puede eliminar el registro'
      );
    } else {
      this.detail_hotels.splice(index, 1);
      this.alertifyMsg.warning(
        'El hotel ' + data_hotel.tradename + ' ha sido removido'
      );
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    if (this.validate()) {

      if(this.item.value.total_paid == 0){
        if(!this.item.value.is_control_total_received){
          this.item.patchValue({
            total: 0
          });
        }
      }

      let data: any = {};
      data.book = this.item.value;
      data.tours = this.detail_tours;
      data.detail_hotels = this.detail_hotels;
      if (this.isEdit) {
        this.bookingsService.updateReceiveds(this.checkId, data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.detail(this.checkId);
          }
        });
      } else {
        this.bookingsService.saveReceiveds(data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.detail(data.data.id);
            // this.cancel();
          }
        });
      }
    }
  }

  validate() {
    if (this.agencySelected == null) {
      this.alertifyMsg.warning(
        'Debe seleccionar la agencia que esta pasando los tours'
      );
      this.SearchAgenciesComponent.focused();
      return false;
    }

    if (this.clientSelected == null) {
      this.alertifyMsg.warning('Debe seleccionar el cliente responsable');
      this.SearchClientComponent.focused();
      return false;
    }

    if (this.detail_tours.length == 0) {
      this.alert.msgWarning(
        'Debe registrar por lo menos un tours al detalle de la reserva'
      );
      return false;
    } else {
      for (let i in this.detail_tours) {
        let _item = this.detail_tours[i];
        if (Number(_item.quantity) == 0 || _.isNull(_item.quantity)) {
          this.alertifyMsg.warning(
            'El N° pax para el tours ' +
              _item.description +
              '  no puede ser igual a cero o estar vacío.'
          );
          (<any>$('#tours_quantity' + i)).focus();
          return false;
        }

        if (_.isNull(_item.date_assigned)) {
          this.alertifyMsg.warning(
            'La fecha asignada para el tours ' +
              _item.description +
              ' no puede estar vacío.'
          );
          (<any>$('#date_assigned' + i)).focus();
          return false;
        }
      }
    }

    if (this.item.value.reference_location == null) {
      this.alertifyMsg.warning(
        'Debe ingresar la ubicación para el recojo del turista'
      );
      (<any>$('#reference_location')).focus();
      return false;
    }

    return true;
  }

  detail(id: any) {
    this.router.navigate([
      this.branchofficeSlug + '/reservas/recibidos/detalle',
      id
    ]);
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/reservas/recibidos/lista']);
  }
}
